import axios, { AxiosResponse } from 'axios';
import { getConfig } from '../config';

const BASE_URL = getConfig().api.baseUrl;

export interface SupportRequestRequest {
    name: string;
    email: string;
    requestType: string;
    title: string;
    description: string;
}

export interface SupportRequestResponse {}
/**
 * HelpApiContextType provides an API for interacting with the help functionality.
 */
export type HelpApiContextType = {
    /**
     * createSupportRequest creates a new support request.
     * @param req The support request to create.
     * @returns
     */
    createSupportRequest: (
        req: SupportRequestRequest
    ) => Promise<AxiosResponse<void, any>>;
};

export function createSupportRequest(idToken: string, req: SupportRequestRequest) {
    if (idToken) {
        return axios.post<void>(`${BASE_URL}/support-request`, req, {
            headers: { Authorization: `Bearer ${idToken}` },
        });
    }
    return axios.post<void>(`${BASE_URL}/public/support-request`, req);
}
